import { motion } from "framer-motion";
import { MapPin, PawPrint } from "lucide-react";
import { IMAGES } from "../data/content";

export const Hero = () => {
    return (
        <section id="top" className="relative min-h-screen flex items-end overflow-hidden" data-testid="hero-section">
            <img
                src={IMAGES.pavilionUmbrellas}
                alt="Uncover Avenue pavilion and colourful garden umbrellas"
                className="absolute inset-0 w-full h-full object-cover"
                data-testid="hero-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#262055]/85 via-[#262055]/30 to-transparent" />

            <div className="relative z-10 max-w-7xl mx-auto w-full px-6 md:px-10 pb-24 pt-40">
                <motion.p
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7 }}
                    className="font-serif-brand italic text-xl md:text-2xl text-[#FFF7C5] mb-4"
                    data-testid="hero-hindi-tagline"
                >
                    Your getaway in the heart of the city
                </motion.p>

                <motion.h1
                    initial={{ opacity: 0, y: 32 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.15 }}
                    className="hero-headline text-white text-5xl md:text-7xl lg:text-8xl font-extrabold tracking-tighter leading-[0.95]"
                    data-testid="hero-headline"
                >
                    An escape<br />
                    <span className="text-[#F0841B]">within</span> the city.
                </motion.h1>

                <motion.p
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.3 }}
                    className="mt-6 max-w-xl text-base md:text-lg text-white/85 leading-relaxed"
                    data-testid="hero-subcopy"
                >
                    Nestled in nature and wrapped in flavours, where families, friends and pets
                    come together to feel at home. Come as you are, leave refreshed and connected.
                </motion.p>

                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.45 }}
                    className="mt-10 flex flex-wrap items-center gap-4"
                >
                    <a
                        href="#reserve"
                        data-testid="hero-reserve-button"
                        className="rounded-full bg-[#F0841B] text-white font-semibold px-9 py-4 shadow-xl shadow-black/25 hover:brightness-110 hover:-translate-y-0.5 transition-[transform,filter] duration-200"
                    >
                        Reserve a Table
                    </a>
                    <a
                        href="#esak"
                        data-testid="hero-explore-esak-button"
                        className="rounded-full border-2 border-white/70 text-white font-semibold px-9 py-4 hover:bg-white/10 transition-colors duration-200"
                    >
                        Explore Esak
                    </a>
                    <span className="flex items-center gap-2 text-white/80 text-sm ml-2" data-testid="hero-pet-friendly-badge">
                        <PawPrint size={18} /> Pet friendly
                    </span>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.7 }}
                    className="mt-12 flex items-center gap-2 text-white/70 text-sm"
                    data-testid="hero-location-line"
                >
                    <MapPin size={16} className="text-[#F0841B]" />
                    Sector 13, Dwarka · New Delhi
                </motion.div>
            </div>
        </section>
    );
};
